"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdownReactJs = _interopRequireDefault(require("markdown-react-js"));

var _highlightjs = require("highlightjs");

var _lib = require("../../lib");

var _Table = _interopRequireDefault(require("../Table"));

require("./styles.css");

require("./code.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Markdown =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Markdown, _PureComponent);

  function Markdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Markdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Markdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "initHighlight", function () {
      var blocks = Array.from(document.querySelectorAll('pre code'));

      if ((0, _lib.arrayHasItems)(blocks)) {
        blocks.forEach(function (b) {
          return (0, _highlightjs.highlightBlock)(b);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleIterate", function (Tag, props, children) {
      var onIterate = _this.props.onIterate;

      if (onIterate) {
        var NewTag = onIterate(Tag, props, children);

        if (NewTag) {
          return NewTag;
        }
      }

      var newProps = props;
      var language = newProps['data-language'];

      switch (Tag) {
        case 'table':
          newProps.className = _Table["default"].className;
          break;

        case 'code':
          if (language) {
            var _highlight = (0, _highlightjs.highlight)(language, children[0]),
                value = _highlight.value;

            return _react["default"].createElement(Tag, _extends({}, newProps, {
              dangerouslySetInnerHTML: {
                __html: value
              }
            }));
          }

          break;

        default:
          return _react["default"].createElement(Tag, newProps, children);
      }

      return _react["default"].createElement(Tag, newProps, children);
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Markdown.className];
      (0, _lib.addDefaultCSS)(names);
      return names.join(' ');
    });

    return _this;
  }

  _createClass(Markdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initHighlight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var src = this.props.src;

      if (prevProps.src !== src) {
        this.initHighlight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          onIterate = _this$props.onIterate,
          rest = _objectWithoutProperties(_this$props, ["src", "onIterate"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react["default"].createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), src ? _react["default"].createElement(_markdownReactJs["default"], {
        text: src,
        onIterate: this.handleIterate
      }) : null);
    }
  }]);

  return Markdown;
}(_react.PureComponent);

exports["default"] = Markdown;

_defineProperty(Markdown, "className", 'MHub-Markdown');

_defineProperty(Markdown, "propTypes", {
  src: _propTypes["default"].string,
  onIterate: _propTypes["default"].func
});

_defineProperty(Markdown, "defaultProps", {
  src: null,
  onIterate: null
});